import type { StoreRoom } from './StoreModal';
import './StoreLobby.css';

interface StoreLobbyProps {
  availableRovers: number;
  playerMoney: number;
  hasPurchasedRover: boolean;
  onNavigate: (room: StoreRoom) => void;
  onExit: () => void;
}

export default function StoreLobby({
  availableRovers,
  playerMoney,
  hasPurchasedRover,
  onNavigate,
  onExit,
}: StoreLobbyProps) {
  return (
    <div className="store-lobby">
      {/* Shopkeeper */}
      <div className="shopkeeper-section">
        <div className="shopkeeper-sprite">
          {/* 8-bit shopkeeper sprite - will be replaced with actual sprite */}
          <div className="shopkeeper-placeholder">
            👨‍🔧
          </div>
        </div>
        <div className="shopkeeper-dialogue">
          <div className="dialogue-box">
            {!hasPurchasedRover ? (
              <>
                <p>"Welcome to R.O.V.E.R. DEPOT!"</p>
                <p>"Need a rover for your operations?"</p>
              </>
            ) : (
              <>
                <p>"Great choice! Now outfit your rover"</p>
                <p>"in one of our specialized rooms!"</p>
              </>
            )}
          </div>
        </div>
      </div>

      {/* Store Status */}
      <div className="store-status-panel">
        <h3>📊 STORE STATUS</h3>
        <div className="status-grid">
          <div className="status-item">
            <span className="status-label">Available Rovers:</span>
            <span className="status-value highlight">{availableRovers}</span>
          </div>
          <div className="status-item">
            <span className="status-label">Your Money:</span>
            <span className="status-value money">{playerMoney} CT</span>
          </div>
        </div>
      </div>

      {/* Navigation */}
      <div className="lobby-navigation">
        <h3>🚪 WHERE TO?</h3>
        
        <button 
          className="nav-button rover-sales"
          onClick={() => onNavigate('rover-sales')}
        >
          <span className="nav-icon">🤖</span>
          <div className="nav-content">
            <div className="nav-title">ROVER SALES</div>
            <div className="nav-description">Purchase rovers (100 CT)</div>
          </div>
          <span className="nav-arrow">➡️</span>
        </button>

        {hasPurchasedRover && (
          <div className="outfitting-section">
            <h4>🔧 OUTFITTING ROOMS</h4>
            
            <button 
              className="nav-button outfit food"
              onClick={() => onNavigate('outfit-food')}
            >
              <span className="nav-icon">🥗</span>
              <div className="nav-content">
                <div className="nav-title">FOOD PRODUCTION</div>
                <div className="nav-description">Greenhouse (50 CT)</div>
              </div>
              <span className="nav-arrow">➡️</span>
            </button>

            <button 
              className="nav-button outfit energy"
              onClick={() => onNavigate('outfit-energy')}
            >
              <span className="nav-icon">⚡</span>
              <div className="nav-content">
                <div className="nav-title">ENERGY GENERATION</div>
                <div className="nav-description">Solar Array (25 CT)</div>
              </div>
              <span className="nav-arrow">➡️</span>
            </button>

            <button 
              className="nav-button outfit mining"
              onClick={() => onNavigate('outfit-mining')}
            >
              <span className="nav-icon">⛏️</span>
              <div className="nav-content">
                <div className="nav-title">MINING OPERATIONS</div>
                <div className="nav-description">Drill Bay (40 CT)</div>
              </div>
              <span className="nav-arrow">➡️</span>
            </button>

            <button 
              className="nav-button outfit water"
              onClick={() => onNavigate('outfit-water')}
            >
              <span className="nav-icon">💧</span>
              <div className="nav-content">
                <div className="nav-title">WATER COLLECTION</div>
                <div className="nav-description">Cryo Bay (35 CT)</div>
              </div>
              <span className="nav-arrow">➡️</span>
            </button>

            <button 
              className="nav-button outfit helium3"
              onClick={() => onNavigate('outfit-helium3')}
            >
              <span className="nav-icon">⚛️</span>
              <div className="nav-content">
                <div className="nav-title">HELIUM-3 EXTRACTION</div>
                <div className="nav-description">Extraction Lab (45 CT)</div>
              </div>
              <span className="nav-arrow">➡️</span>
            </button>
          </div>
        )}

        <button 
          className="nav-button resource-sales"
          onClick={() => onNavigate('resource-sales')}
        >
          <span className="nav-icon">💰</span>
          <div className="nav-content">
            <div className="nav-title">RESOURCE SALES</div>
            <div className="nav-description">Sell resources for CT</div>
          </div>
          <span className="nav-arrow">➡️</span>
        </button>

        <button 
          className="nav-button exit"
          onClick={onExit}
        >
          <span className="nav-icon">🚪</span>
          <div className="nav-content">
            <div className="nav-title">EXIT TO MAP</div>
            <div className="nav-description">Return to lunar surface</div>
          </div>
          <span className="nav-arrow">➡️</span>
        </button>
      </div>
    </div>
  );
}

